import { createContext, useState } from "react";

export const ConfigurationContext = createContext();

export const ConfigurationProvider = ({ children }) => {
    
    const [clients, setClients] = useState(null);

    return (
        <ConfigurationContext.Provider value={{
            clients,
            setClients
        }}>
            {children}
        </ConfigurationContext.Provider>
    )
}
